import { render, staticRenderFns } from "./AccountStep.vue?vue&type=template&id=03bed2c7&scoped=true"
import script from "./AccountStep.vue?vue&type=script&lang=js"
export * from "./AccountStep.vue?vue&type=script&lang=js"
import style0 from "./AccountStep.vue?vue&type=style&index=0&id=03bed2c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bed2c7",
  null
  
)

export default component.exports